import { IconProps } from "@/src/sb/business-layer/types"

const X = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8243 5.17574C15.0586 5.41005 15.0586 5.78995 14.8243 6.02426L10.8488 10L14.8243 13.9757C15.0586 14.2101 15.0586 14.5899 14.8243 14.8243C14.5899 15.0586 14.2101 15.0586 13.9757 14.8243L10 10.8488L6.02426 14.8243C5.78995 15.0586 5.41005 15.0586 5.17574 14.8243C4.94142 14.5899 4.94142 14.2101 5.17574 13.9757L9.15125 10L5.17574 6.02426C4.94142 5.78995 4.94142 5.41005 5.17574 5.17574C5.41005 4.94142 5.78995 4.94142 6.02426 5.17574L10 9.15125L13.9757 5.17574C14.2101 4.94142 14.5899 4.94142 14.8243 5.17574Z"
      fill="currentColor"
    />
  </svg>
)

export default X
